export enum PaymentMethod {
	CASH = 'cash',
	CARD = 'card',
}
